import type { AutomationWorkflow } from '../../../../api/automations-workflows-client/automations-workflows-client.type';

enum AutomationFilter {
  ALL = 'ALL',
  ACTIVE = 'ACTIVE',
  PAUSED = 'PAUSED',
}

enum AutomationGroupKey {
  EVENT = 'EVENT',
  CRON = 'CRON',
  MANUAL = 'MANUAL',
}

const GROUP_LABELS: Record<AutomationGroupKey, string> = {
  [AutomationGroupKey.EVENT]: 'EVENT TRIGGERED',
  [AutomationGroupKey.CRON]: 'SCHEDULED',
  [AutomationGroupKey.MANUAL]: 'MANUAL',
};

type AutomationGroup = {
  key: AutomationGroupKey;
  label: string;
  workflows: AutomationWorkflow[];
};

type AutomationCounts = {
  all: number;
  active: number;
  paused: number;
};

type ActionStepVisual = {
  icon: string;
  iconColor: string;
  iconBackground: string;
};

type InsertAtCursorInput = {
  element: HTMLTextAreaElement | null;
  currentValue: string;
  token: string;
};

type InsertAtCursorResult = {
  nextValue: string;
  caretIndex: number;
};

interface AutomationFilterOptionInput {
  value: unknown;
  label: unknown;
}

interface AutomationFilterOption {
  value: string;
  label: string;
}

export { AutomationFilter, AutomationGroupKey, GROUP_LABELS };
export type {
  ActionStepVisual,
  AutomationCounts,
  AutomationFilterOption,
  AutomationFilterOptionInput,
  AutomationGroup,
  InsertAtCursorInput,
  InsertAtCursorResult,
};
